import React from 'react';
import { render } from 'react-dom';

import PackageSearch from '../react/PackageSearch';

export default class PackageSearchRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { apiUrl, model, crmToursearchApiUrl } = this.context.dataset;
    if (!apiUrl || !model || !crmToursearchApiUrl) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);
    render(
      <PackageSearch {...jsonModel} apiURL={apiUrl} crmApiURL={crmToursearchApiUrl} />,
      this.context
    );
  }
}
